var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "py-16 px-24",
    attrs: {
      "flat": "",
      "color": "grey-f1",
      "rounded": "lg"
    }
  }, [_c('p', {
    staticClass: "page--text text-center mb-10"
  }, [_c('span', [_vm._v(" 최종 매칭된 지원자의 연락처는 인터뷰 데이 시작일에 기업에게 공개됩니다. ")]), _vm._v(" "), _c('br'), _c('span', [_vm._v(" 온라인 인터뷰를 선택하시면, 마이스펙에서제공하는 비대면인터뷰 기능을 이용할 수 있습니다. ")])]), _c('p', {
    staticClass: "page--text text-center"
  }, [_c('span', [_vm._v(" 인터뷰 시간에 맞춰 '온라인 인터뷰' 버튼을 클릭해 주세요. ")]), _vm._v(" "), _c('br'), _c('span', [_vm._v(" 인터뷰 신청 후 기업의 승인이 완료되면, 매칭 정보에 '매칭 완료'로 표시됩니다. ")]), _vm._v(" "), _c('br'), _c('span', [_vm._v(" 매칭 기간 종료 후, 인터뷰 기간에 인터뷰가 진행됩니다. ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }